import GenerateMorePopover from 'trunks/controllers/admin/settings/nav.js'
import ToggleNavMenuAction from 'trunks/controllers/admin/toggle_nav_menu_action.js'
import CategoriesApp from 'trunks/vue/admin/components/categories/categories_app.js'
import CategoriesSidebar from 'trunks/vue/admin/components/categories/categories_sidebar.js'
import { mountVue, unmountVue } from 'trunks/vue/share/mount.js'

class Admin__CategoriesController extends Skylark.App.BaseController {
  index() {
    const container = DomMaster.find('#categories_container').node
    if (!container) return

    this.__toggleNavMenu()
    this._generateCategoriesSidebar()

    mountVue(CategoriesApp, {
      el: container,
      props: {
        mode: 'index',
        canManageCategories: container.dataset.canManageCategories === 'true',
        templates: JSON.parse(container.dataset.templates || '[]'),
        searchTemplates: JSON.parse(container.dataset.searchTemplates || '[]')
      }
    })
  }

  show() {
    const container = DomMaster.find('#categories_container').node
    if (!container) return

    this.__toggleNavMenu()
    this._generateCategoriesSidebar(container.dataset.categoryId)

    const categoryId = container.dataset.categoryId

    Skylark.Libs.Ajax.get(`/admin/categories/${categoryId}.json`, {
      responseType: 'json',
      success: (payload) => {
        mountVue(CategoriesApp, {
          el: container,
          props: {
            mode: 'show',
            initialPayload: payload,
            canManageCategories: container.dataset.canManageCategories === 'true'
          }
        })
      }
    })
  }

  _generateCategoriesSidebar(currentCategoryId) {
    const sidebar = DomMaster.find('#categories_sidebar').node
    if (!sidebar) return

    let mountNode = sidebar.querySelector('.categories-sidebar-container')
    if (!mountNode) {
      const currentSidebar = sidebar.querySelector('.sidebar-categories')
      if (currentSidebar) {
        unmountVue(currentSidebar)
        currentSidebar.remove()
      }
      mountNode = document.createElement('div')
      mountNode.className = 'categories-sidebar-container'
      sidebar.appendChild(mountNode)
    }

    const selectedCategoryId = currentCategoryId || sidebar.dataset.selectedCategoryId || ''
    const initialCategories = JSON.parse(sidebar.dataset.categories || '[]')

    mountVue(CategoriesSidebar, {
      el: mountNode,
      props: {
        initialCategories,
        selectedCategoryId
      }
    })
  }
}

Admin__CategoriesController.include(GenerateMorePopover)
Admin__CategoriesController.include(ToggleNavMenuAction)

export default Admin__CategoriesController
